import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidationErrors, Validator, AbstractControl } from '@angular/forms';

export interface BundleTimeSlot {
    time: string;
    cutOff: number;
    maxOrders: number;
}

@Component({
    selector: 'app-bundle-time-slot',
    templateUrl: './bundle-time-slot.component.html',
    styleUrls: ['./bundle-time-slot.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BundleTimeSlotComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => BundleTimeSlotComponent),
            multi: true
        }
    ]
})
export class BundleTimeSlotComponent implements ControlValueAccessor, Validator {
    @Input() disabled: boolean = false;

    dayForm: FormGroup;

    private onChange = (value: BundleTimeSlot) => { };
    private onTouched = () => { };
    private onValidatorChange = () => { };

    constructor(
        private fb: FormBuilder,
    ) {
        this.dayForm = this.fb.group({
            time: [''],
            cutOff: [''],
            maxOrders: ['']
        }/*, { validators: TimeRangeValidators.timeRange("from", "to") }*/);

        this.dayForm.valueChanges.subscribe(value => {
            this.onChange(value);
            this.onTouched();
        });
        this.dayForm.statusChanges.subscribe(() => {
            this.onValidatorChange();
        });
    }

    // ControlValueAccessor implementation
    writeValue(value: BundleTimeSlot): void {
        if (value) {
            this.dayForm.patchValue(value, { emitEvent: false });
        }
    }

    registerOnChange(fn: (value: BundleTimeSlot) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.dayForm.disable();
        } else {
            this.dayForm.enable();
        }
    }

    // Validator implementation
    validate(control: AbstractControl): ValidationErrors | null {
        if (this.dayForm && this.dayForm.invalid) {
            return { dayTimeSlotInvalid: true };
        }
        return null;
    }

    registerOnValidatorChange(fn: () => void): void {
        this.onValidatorChange = fn;
    }

    // Time validation methods
    validateTimeRange(): void {
        // Trigger form validation using the TimeRangeValidators
        this.dayForm.updateValueAndValidity();
    }

    onTimeChange(): void {
        this.validateTimeRange();
        // Trigger validation update for parent form
        this.onValidatorChange();
    }

    onValueChange(): void {
        // Trigger validation update for parent form when any value changes
        this.onValidatorChange();
    }

    get timeControl() {
        return this.dayForm.get('time');
    }

    get cutOffControl() {
        return this.dayForm.get('cutOff');
    }

    get maxOrdersControl() {
        return this.dayForm.get('maxOrders');
    }
}
